var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPinF = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12 2c-4.69 0-8.5 3.81-8.5 8.5 0 2.25 1.05 4.15 2.31 5.82 1.59 2.08 3.51 3.83 4.74 5.05.37.37.88.63 1.45.63s1.08-.26 1.45-.63c1.22-1.22 3.15-2.97 4.74-5.05 1.27-1.66 2.31-3.56 2.31-5.82C20.5 5.81 16.69 2 12 2m0 11.5c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3"
})));
export default SvgPinF;